import http from "./http";

export function listMembers(params) {
  return http.get("/members", { params });
}

export function createMember(payload) {
  return http.post("/members", payload);
}

export function updateMember(id, payload) {
  return http.patch(`/members/${id}`, payload);
}

export function toggleMemberActive(id, isActive) {
  return http.patch(`/members/${id}/toggle-active`, { is_active: isActive });
}
export function importMembers(formData) {
  return http.post("/members/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function downloadMembersTemplate() {
  return http.get("/members/import/template", {
    responseType: "blob",
  });
}